module.exports = __webpack_public_path__ + "img/icon_success.d4f1c70e.png";